import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddPaymentRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPayment/types/requests/AddPaymentRequest';

type AddPaymentSliceInitialState = {
  addPaymentIsLoading: boolean;
};

const initialState: AddPaymentSliceInitialState = {
  addPaymentIsLoading: false,
};

const addPaymentSlice = createSlice({
  name: 'addPaymentSlice',
  initialState,
  reducers: {
    addPayment(state, _action: PayloadAction<AddPaymentRequestBody>) {
      state.addPaymentIsLoading = true;
    },
    addPaymentSuccess(state, _action: PayloadAction<{ claimId: number }>) {
      state.addPaymentIsLoading = false;
    },
    addPaymentError(state) {
      state.addPaymentIsLoading = false;
    },
  },
});

export const { addPayment, addPaymentSuccess, addPaymentError } = addPaymentSlice.actions;

export const addPaymentReducer = addPaymentSlice.reducer;
export const addPaymentReducerPath = addPaymentSlice.reducerPath;
